var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-generic-entity-select',_vm._g(_vm._b({attrs:{"store":_vm.store,"itemFilter":_vm.itemFilter}},'input-generic-entity-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }